<template>
  <div>
    <div class="container">
      <input type="text" v-model="artworkUrl" />
      <img :src="artworkUrl" alt="" class="artwork-cover" />
      <div class="palettes">
        <div
          v-for="(key, index) in Object.keys(colorPalette)"
          :key="index"
          :style="{ backgroundColor: colorPalette[key] }"
          class="palette"
        >
          <p>{{ key }}</p>
          <p>{{ colorPalette[key] }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { getBlobFromUrl, convertBlobToBase64, getConfigForNetwork } from '../utils'
import * as Vibrant from 'node-vibrant'

@Component({})
export default class Main extends Vue {
  artworkUrl = ''
  artworkBase64 = ''
  colorPalette = {
    darkMuted: '',
    darkVibrant: '',
    lightMuted: '',
    lightVibrant: '',
    muted: '',
    vibrant: ''
  }

  mounted() {
    const config = getConfigForNetwork()
    console.log(config)
  }

  @Watch('artworkUrl')
  async onArtworkUrlChanged() {
    const imgUrlHTTPS = this.artworkUrl.replace('http:', 'https:')
    const blob = await getBlobFromUrl(imgUrlHTTPS)
    this.artworkBase64 = await convertBlobToBase64(blob)
    const palette = await this.getVibrantPaletteByArtwork(this.artworkBase64)
    this.colorPalette = {
      darkMuted: palette.DarkMuted.getHex(),
      darkVibrant: palette.DarkVibrant.getHex(),
      lightMuted: palette.LightMuted.getHex(),
      lightVibrant: palette.LightVibrant.getHex(),
      muted: palette.Muted.getHex(),
      vibrant: palette.Vibrant.getHex()
    }
  }

  async getVibrantPaletteByArtwork(imgSource) {
    const palette = await Vibrant.from(imgSource).getPalette()
    return palette
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: auto;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
}
.palettes {
  display: flex;
  margin: 2em 0;
  .palette {
    color: white;
    width: 100%;
  }
}
.artwork-cover {
  width: 200px;
}
</style>
